import { Controller } from 'stimulus'
import { useDispatch } from 'stimulus-use'

export default class extends Controller {
  static targets = ['turnOnSwitch', 'turnOffSwitch', 'switchInput']

  connect() {
    useDispatch(this)

    this.handlePaymentProcessorChanged = (e) => {
      this.applySupportsSplitPayments(e.detail.supportsSplitPayments)
    }

    document.addEventListener(
      'payment_processor:changed',
      this.handlePaymentProcessorChanged
    )

    // payment_form_component_controller dispatches its own initial payment_processor:changed
    // from connect() too, but that's a transient event: if it fires before we've connected
    // (Stimulus controllers can load - and thus connect - in any order, since each one's JS
    // is its own dynamically-loaded chunk) we'd never see it, and the switch would stay
    // hidden regardless of how long we waited. The supports-split-payments state it would
    // send is already sitting in the server-rendered HTML on the active processor's button
    // though (see payment_form_component.html.erb), so read that directly as our own initial
    // state instead of only ever reacting to the live event.
    const activeProcessor = document.querySelector(
      '[data-payment-processor--payment-form-target~="activePaymentProcessor"]'
    )
    if (activeProcessor) {
      this.applySupportsSplitPayments(
        activeProcessor.getAttribute(
          'data-payment-processor--payment-form-supports-split-payments-param'
        ) === 'true'
      )
    }
  }

  disconnect() {
    document.removeEventListener(
      'payment_processor:changed',
      this.handlePaymentProcessorChanged
    )
  }

  applySupportsSplitPayments(supportsSplitPayments) {
    if (supportsSplitPayments === true) {
      this.element.classList.remove('hidden')

      // The switch is a persistent checkbox that never gets unmounted while browsing
      // payment methods, so it can still be checked from before we hid it. Re-sync the
      // amount input to match, since hiding it (below) never touched the checkbox itself.
      if (this.hasSwitchInputTarget && this.switchInputTarget.checked) {
        this.dispatch('useSplitPayments')
      }
    } else {
      this.element.classList.add('hidden')
      this.dispatch('cancelSplitPayments')
    }
  }

  toggleSplitPayments(e) {
    if (e.target.checked) {
      this.dispatch('useSplitPayments')
    } else {
      this.dispatch('cancelSplitPayments')
    }
  }
}
